// Single source of truth for every backend-API default, matching the SDK-wide
// rule that a default has exactly ONE declaration (ADR-025). Consumers keep
// their own `= DEFAULT_API.x` parameter defaults; the literal lives only here.
//
// There is deliberately NO default baseUrl. The documented host
// (api.playbid.example.com) is a placeholder in a PROPOSED contract, and
// baking it in as a fallback would let a misconfigured build silently point at
// an example domain instead of failing loudly at construction.
export const DEFAULT_API = Object.freeze({
  timeoutMs: 10000,

  auth: Object.freeze({
    enabled: true,
    refreshSkewMs: 60000,
  }),

  telemetry: Object.freeze({
    enabled: true,
    batchSize: 20,
    flushIntervalMs: 5000,
    maxQueueSize: 500,
    heartbeatIntervalMs: 10000,
    // Advertisement events (impression, start, quartiles, click) feed the same
    // dashboard totals as the `/v1/e` beacons boot() fires, so a page that
    // sends both counts every ad twice. boot() turns these off; a page that
    // wires widgets itself without boot() keeps them on.
    adEvents: true,
  }),

  logging: Object.freeze({
    enabled: false,
  }),
});
